export const liveBetsCounter = (arr: any) =>
    arr.reduce((p: any, c: any) => c.bet ? p = p + 1 : p, 0)
